import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from "../context/UserContext";

type PrivateRouteProps = {
  children: ReactNode;
  allowedRoles?: string[];
};

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, allowedRoles }) => {
  const { user } = useUser();

  if (!user) return <Navigate to="/login" replace />;

  if (allowedRoles) {
    const roles = user.user.roles || [];
    const hasAccess = roles.some((r: string) => allowedRoles.includes(r));

    if (!hasAccess) return <Navigate to="/welcome" replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;

